import ExchangeDashboard from './pages/Dashboard'
import ExchangeSettings from "./pages/ExchangeSettings"
import ExchangeReports from '@/reports/pages/Activity'
import ExchangeAdReview from '@/reports/pages/AdReview'
import ExchangeExplorer from '@/reports/pages/Explorer/Explorer'
import ReportApi from '../components/ReportApi'

export default [
  {
    path: '/exchange/dashboard',
    name: 'ExchangeDashboard',
    props: true,
    component: ExchangeDashboard,
    meta: {
      title: 'Exchange Dashboard Reports',
      breadcrumbs: [
        {name: 'Exchange', to: {name: 'ExchangeSettings', params: ['cid']}},
        {name: 'Dashboard'}
      ]
    }
  },
  {
    path: '/exchange/api',
    name: 'ExchangeApi',
    props: true,
    component: ReportApi,
    meta: {
      title: 'Exchange Report API',
      breadcrumbs: [
        {name: 'Exchange', to: {name: 'ExchangeSettings', params: ['cid']}},
        {name: 'Reporting API'}
      ]
    }
  },
  {
    path: '/exchange/:cid/reports',
    name: 'ExchangeReports',
    props: true,
    component: ExchangeReports,
    meta: {
      title: 'Exchange Reporting',
      breadcrumbs: [
        {name: 'Exchange', to: {name: 'ExchangeSettings', params: ['cid']}},
        {name: 'Reports'}
      ]
    }
  },
  {
    path: '/exchange/:cid/settings',
    name: 'ExchangeSettings',
    component: ExchangeSettings,
    props: true,
    meta: {
      breadcrumbs: [
        {name: 'Exchange Settings'}
      ]
    }
  },
  {
    path: '/exchange/:cid/adreview',
    name: 'ExchangeAdReview',
    props: true,
    component: ExchangeAdReview,
    meta: {
      title: 'Live Ad Review',
      breadcrumbs: [
        {name: 'Exchange', to: {name: 'ExchangeSettings', params: ['cid']}},
        {name: 'Ad Review'}
      ]
    }
  },
  {
    path: '/exchange/reports/explorer',
    name: 'ExchangeExplorer',
    props: true,
    component: ExchangeExplorer,
    meta: {
      title: 'Inventory Explorer',
      breadcrumbs: [
        {name: 'Exchange', to: {name: 'ExchangeSettings', params: ['cid']}},
        {name: 'Inventory Explorer'}
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/exchange/routes.js